export const PRODUCTS_API_BASE_URL = 'ui/partner/products';

export const productsQueryKeys = {
  all: [PRODUCTS_API_BASE_URL],
  byIds: (productIds: string[]) => [...productsQueryKeys.all, ...productIds],
  categories: () => [...productsQueryKeys.all, 'categories'],
};
